module.exports = __webpack_public_path__ + "img/402244d.png";